import { decisioningStudioAgentsAppGroupIdDsaIdCreativeComponents } from "../decisioningStudioAgentsAppGroupIdDsaIdCreativeComponents/constants";
import { decisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsComponentVariants } from "../decisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsComponentVariants/constants";
import type { AllRouteEndpoints } from "../routeTypes";

export const decisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsComponentVariantsVariantId: AllRouteEndpoints =
  "/decisioning_studio_agents/:app_group_id/:dsa_id/creative_components/:component/variants/:variant_id";

export const putDecisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsComponentVariantsVariantIdCacheKeys: AllRouteEndpoints[] =
  [decisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsComponentVariants];

export const deleteDecisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsComponentVariantsVariantIdCacheKeys: AllRouteEndpoints[] =
  [
    decisioningStudioAgentsAppGroupIdDsaIdCreativeComponentsComponentVariants,
    decisioningStudioAgentsAppGroupIdDsaIdCreativeComponents,
  ];
